// SystemA Web版 — MemoryRouter + 全ページ統合
import React from 'react'
import ReactDOM from 'react-dom/client'
import { MemoryRouter, Routes, Route, Link, useLocation } from 'react-router-dom'
import Home from '../../src/pages/Home'
import Customer from '../../src/pages/Customer'
import Item from '../../src/pages/Item'
import Setting from '../../src/pages/Setting'
import Estimate from '../../src/pages/Estimate'
import EstimateEdit from '../../src/pages/EstimateEdit'
import Order from '../../src/pages/Order'
import OrderEdit from '../../src/pages/OrderEdit'
import Schedule from '../../src/pages/Schedule'
import Delivery from '../../src/pages/Delivery'
import DeliveryEdit from '../../src/pages/DeliveryEdit'
import Invoice from '../../src/pages/Invoice'
import InvoiceEdit from '../../src/pages/InvoiceEdit'
import '../../src/styles/global.css'
import '../../src/lib/api-web'

const navItems = [
  { path: '/', label: 'ホーム', icon: '📊' },
  { path: '/customer', label: '顧客', icon: '👥' },
  { path: '/item', label: '品目', icon: '📦' },
  { path: '/estimate', label: '見積', icon: '📝' },
  { path: '/order', label: '注文請書', icon: '📄' },
  { path: '/schedule', label: '工程表', icon: '📅' },
  { path: '/delivery', label: '納品書', icon: '🚚' },
  { path: '/invoice', label: '請求書', icon: '💰' },
  { path: '/setting', label: '設定', icon: '⚙️' },
]

class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { error: Error | null }
> {
  state = { error: null as Error | null }
  static getDerivedStateFromError(error: Error) { return { error } }
  render() {
    if (this.state.error) {
      const e: any = this.state.error
      return (
        <div style={{ padding: 24, fontFamily: 'monospace', color: '#b91c1c' }}>
          <h2>エラー</h2>
          <p><b>{String(e?.name)}:</b> {String(e?.message)}</p>
          <pre style={{ background: '#fef2f2', padding: 12, whiteSpace: 'pre-wrap', fontSize: 11 }}>{String(e?.stack)}</pre>
          <button onClick={() => this.setState({ error: null })}>再試行</button>
        </div>
      )
    }
    return this.props.children as any
  }
}

const Sidebar: React.FC = () => {
  const loc = useLocation()
  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h1 className="sidebar-title">SystemA</h1>
        <p className="sidebar-subtitle">株式会社エスティー</p>
      </div>
      <nav className="sidebar-nav">
        {navItems.map((item) => {
          const active = item.path === '/' ? loc.pathname === '/' : loc.pathname.startsWith(item.path)
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${active ? 'nav-item-active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </Link>
          )
        })}
      </nav>
    </aside>
  )
}

const Shell: React.FC = () => {
  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<ErrorBoundary><Home /></ErrorBoundary>} />
          <Route path="/customer" element={<ErrorBoundary><Customer /></ErrorBoundary>} />
          <Route path="/item" element={<ErrorBoundary><Item /></ErrorBoundary>} />
          <Route path="/setting" element={<ErrorBoundary><Setting /></ErrorBoundary>} />
          <Route path="/estimate" element={<ErrorBoundary><Estimate /></ErrorBoundary>} />
          <Route path="/estimate/:id" element={<ErrorBoundary><EstimateEdit /></ErrorBoundary>} />
          <Route path="/estimate/new" element={<ErrorBoundary><EstimateEdit /></ErrorBoundary>} />
          <Route path="/order" element={<ErrorBoundary><Order /></ErrorBoundary>} />
          <Route path="/order/:id" element={<ErrorBoundary><OrderEdit /></ErrorBoundary>} />
          <Route path="/order/new" element={<ErrorBoundary><OrderEdit /></ErrorBoundary>} />
          <Route path="/schedule" element={<ErrorBoundary><Schedule /></ErrorBoundary>} />
          <Route path="/schedule/:orderId" element={<ErrorBoundary><Schedule /></ErrorBoundary>} />
          <Route path="/delivery" element={<ErrorBoundary><Delivery /></ErrorBoundary>} />
          <Route path="/delivery/:id" element={<ErrorBoundary><DeliveryEdit /></ErrorBoundary>} />
          <Route path="/delivery/new" element={<ErrorBoundary><DeliveryEdit /></ErrorBoundary>} />
          <Route path="/invoice" element={<ErrorBoundary><Invoice /></ErrorBoundary>} />
          <Route path="/invoice/:id" element={<ErrorBoundary><InvoiceEdit /></ErrorBoundary>} />
          <Route path="/invoice/new" element={<ErrorBoundary><InvoiceEdit /></ErrorBoundary>} />
        </Routes>
      </main>
    </div>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <MemoryRouter initialEntries={['/']}>
      <Shell />
    </MemoryRouter>
  </ErrorBoundary>
)
